import React from 'react'
// components
// redux
// types
import cx from 'classnames'
import { Classes } from 'jss'
// styles
import injectSheet from 'react-jss'
import { sheet } from './sheet'
import { StateSignUp } from '../../types'
// utils

interface Props<T> {
  value: T
  checked: boolean

  onChange: (value: T) => void
  classes: Classes
  title: string
  subtitle: string
}
const SignUpRadio = <T extends StateSignUp>({
  classes,
  checked,
  value,
  onChange,
  title,
  subtitle
}: Props<T>) => {
  return (
    <>
      <div
        className={cx([
          'transition-ease',
          classes.radio,
          {
            [classes.radioChacked]: checked
          }
        ])}
      >
        <input
          type="radio"
          value={value}
          id={value.toString()}
          checked={checked}
          onChange={() => onChange(value)}
          className={classes.radioInput}
        />
        <label className="d-flex column" htmlFor={value.toString()}>
          <div
            className={cx([
              'text-14 ',
              {
                'text-semibold': checked
              }
            ])}
          >
            {title}
          </div>
          <div className={cx(['text-12 '])}>{subtitle}</div>
        </label>
      </div>
    </>
  )
}

export default injectSheet(sheet)(SignUpRadio)
